// import axios from 'axios';
// import { BASE_URL } from './BaseUrl';

// export const request = async (api, { method, query, params, body }, isAbsolute = false) => {
//   const url = `${BASE_URL}${isAbsolute ? api : api}${params ? '/' + params : ''}`;
//   try {
//     const response = await axios({
//       method,
//       url,
//       params: query,
//       data: body
//     });
//     return response.data;
//   } catch (err) {
//     console.log(err);
//   }
// };
// src/utils/request.js
// utils/request.js
// src/utils/request.js
import axios from "axios";
import { BASE_URL } from "./BaseUrl";

export const request = async (
  api,
  { method = "get", query = {}, params = "", body = null } = {},
  isAbsolute = false
) => {
  // build url (keeps your existing behavior of params => /:id)
  const url = isAbsolute ? api : `${BASE_URL}${api}${params ? `/${params}` : ""}`;

  // token
  const token = typeof window !== "undefined" ? localStorage.getItem("token") : null;

  // Build headers
  const headers = {};
  if (token) headers.Authorization = `Bearer ${token}`;

  // axios config
  const axiosConfig = {
    method,
    url,
    headers,
    params: query,
    // data will be set below depending on body type
    maxBodyLength: Infinity,
  };

  // If body is FormData (file upload), let axios/browser set the Content-Type + boundary.
  // Also do NOT JSON.stringify FormData.
  if (body instanceof FormData) {
    axiosConfig.data = body;
    // do NOT set Content-Type header
  } else if (body !== undefined && body !== null) {
    // normal JSON body
    axiosConfig.headers = { "Content-Type": "application/json", ...axiosConfig.headers };
    axiosConfig.data = typeof body === "string" ? body : JSON.stringify(body);
  }

  try {
    const response = await axios(axiosConfig);
    return response.data;
  } catch (err) {
    // Helpful debug logging
    if (err.response) {
      console.error("API request error:", err.response.status, err.response.data);
      throw err.response.data || err;
    } else {
      console.error("API request error:", err.message);
      throw err;
    }
  }
};

export default request;
